import React, { Component } from 'react'
import EntityEdit from '../../components/entityEdit';
import {GridList, GridTile} from 'material-ui/GridList';

const Styles = {
  content: {
    marginTop: 10,
    marginBottom: 5
  },
  control: {
    marginLeft: 20
  }  
};

class TrailerKijijiEdit extends EntityEdit {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    if(this.state.fields){
      return (
        <div style={Styles.content}>
          <div>
            <style>
              {`
                td{
                  vertical-align: top;
                }
              `}
            </style>
            <table>
              <colgroup>
                <col style={{width: '33%'}} />
                <col style={{width: '33%'}} />
                <col style={{width: '33%'}} />
              </colgroup>          
              <tbody>
                <tr>
                  <td>{this.getComponentFromFieldDef('KijijiActive', this.state.fields.KijijiActive)}</td>
                  <td></td>
                  <td></td>
                </tr>                                                         
              </tbody>
            </table>
          </div>              
        </div>
      )      
    }
    else
      return (<div></div>);
  }  
}

export default TrailerKijijiEdit;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/trailer.kijijiEdit.js
 **/